<template>
  <div class="container">
    <h1 style="padding-top: 2rem">Vaše objednávka</h1>
    <h2>Košík</h2>
    <div class="table-responsive">
      <table class="table table-dark table-striped">
        <thead>
          <tr>
            <th scope="col" style="text-align: center">Obrázek</th>
            <th scope="col">Název</th>
            <th scope="col">Varianta</th>
            <th scope="col">Cena/ks</th>
            <th scope="col">Celkem bez DPH</th>
            <th scope="col">Celkem s DPH</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="variant in cartItems" :key="variant.id">
            <td style="text-align: center; font-size: 1.5rem">
              <img
                v-if="!isTransport(variant)"
                :src="'/assets/img/beers/' + variant.item.image + '.svg'"
                class="center"
                style="height: 8rem"
              />
              <i
                v-if="isTransport(variant)"
                class="fa fa-truck"
                aria-hidden="true"
              ></i>
            </td>
            <td>
              {{ variant.item.name }}
              <div class="small-extid">({{ variant.variant.extId }})</div>
            </td>
            <td>{{ getVariantName(variant.variant.name) }}</td>
            <td>
              {{ variant.count }} x
              {{
                (variant.variant.price + variant.variant.vat).toLocaleString()
              }}
              Kč
            </td>
            <td>
              {{ (variant.count * variant.variant.price).toLocaleString() }} Kč
            </td>
            <td>
              {{
                (
                  variant.count *
                  (variant.variant.price + variant.variant.vat)
                ).toLocaleString()
              }}
              Kč
            </td>
          </tr>
        </tbody>
      </table>
    </div>
      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <table class="table table-borderless table-sm">
             <thead>
          <tr>
            <th scope="col" colspan="2">Součet</th>
          </tr>
        </thead>
            <tbody>
              <tr>
                <td>Celkem bez DPH</td>
                <td >
                  {{ priceSum.withoutVat.toLocaleString() }} Kč
                </td>
              </tr>
              <tr>
                <td>DPH</td>
                <td>{{ priceSum.vat.toLocaleString() }} Kč</td>
              </tr>
              <tr>
                <td>Celkem s DPH</td>
                <td>{{ priceSum.withVat.toLocaleString() }} Kč</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    <h2>Základní a fakturační údaje</h2>

    <div class="form-group row">
      <label for="inputName" class="col-sm-4 col-form-label required"
        >Jméno a příjmení (název firmy)</label
      >
      <div class="col-sm-8">
        <input
          type="text"
          class="form-control"
          id="inputName"
          name="inputName"
          placeholder="Jméno a příjmení (název firmy)"
          v-model="order.name"
          required
        />
        <div class="invalid-feedback">
          Jméno a přímení nebo název firmy jsou povinný údaj
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputCompanyCheckbox" class="col-sm-4 col-form-label"
        >Nákup na firmu</label
      >
      <div class="col-sm-8">
        <input
          type="checkbox"
          id="inputCompanyCheckbox"
          v-model="companyChecked"
        />
      </div>
    </div>
    <div v-if="companyChecked" class="form-group row">
      <label for="inputIco" class="col-sm-4 col-form-label">IČO</label>
      <div class="col-sm-8">
        <input
          type="text"
          class="form-control"
          id="inputIco"
          name="inputIco"
          placeholder="IČO"
          v-model="order.ico"
          pattern="^[0-9]{8}$"
        />
        <div class="invalid-feedback">
          IČO je 8 místné a může obashovat pouze číslice
        </div>
      </div>
    </div>
    <div v-if="companyChecked" class="form-group row">
      <label for="inputDic" class="col-sm-4 col-form-label">DIČ</label>
      <div class="col-sm-8">
        <input
          v-model="order.dic"
          type="text"
          class="form-control"
          id="inputDic"
          name="inputDic"
          placeholder="DIČ"
        />
        <div class="invalid-feedback">DIČ</div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputStreet" class="col-sm-4 col-form-label required"
        >Ulice a číslo popisné</label
      >
      <div class="col-sm-8">
        <input
          type="text"
          v-model="order.street"
          class="form-control"
          id="inputStreet"
          name="inputStreet"
          placeholder="Ulice a číslo popisné"
          required
        />
        <div class="invalid-feedback">Ulice je povinný údaj</div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputZip" class="col-sm-4 col-form-label required">PSČ</label>
      <div class="col-sm-8">
        <input
          type="text"
          v-model="order.zip"
          class="form-control"
          id="inputZip"
          name="inputZip"
          placeholder="PSČ"
          required
        />
        <div class="invalid-feedback">PSČ je povinný údaj</div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputCity" class="col-sm-4 col-form-label required"
        >Město</label
      >
      <div class="col-sm-8">
        <input
          type="text"
          v-model="order.city"
          class="form-control"
          id="inputCity"
          name="inputCity"
          placeholder="Město"
          required
        />
        <div class="invalid-feedback">Město je povinný údaj</div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputEmail" class="col-sm-4 col-form-label required"
        >Email</label
      >
      <div class="col-sm-8">
        <input
          type="email"
          v-model="order.email"
          class="form-control"
          id="inputEmail"
          name="inputEmail"
          placeholder="Email"
          required
        />
        <div class="invalid-feedback">Musí být vložen validní email</div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputPhone" class="col-sm-4 col-form-label required"
        >Telefon</label
      >
      <div class="col-sm-8">
        <input
          type="tel"
          v-model="order.telephone"
          pattern="^[\+]?[0-9]{3}[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$"
          class="form-control"
          id="inputPhone"
          name="inputPhone"
          placeholder="Telefon"
          required
        />
        <div class="invalid-feedback">Musí být vložen validní telefon</div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputNote" class="col-sm-4 col-form-label"
        >Poznámka</label
      >
      <div class="col-sm-8">
        <textarea
          v-model="order.note"
          class="form-control"
          id="inputNote"
          name="inputNote"
          placeholder="Poznámka"
        />
      </div>
    </div>

    <h2>Doprava</h2>
    <div class="form-group row">
      <label for="inputPhone" class="col-sm-4 col-form-label required"
        >Způsob dodání</label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            type="radio"
            id="deliveryRadio1"
            name="deliveryRadio"
            class="form-check-input"
            value="PERSONAL"
            v-model="transport"
            required
          />
          <label class="form-check-label" for="deliveryRadio1"
            >Osobní odběr</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="deliveryRadio2"
            name="deliveryRadio"
            class="form-check-input"
            value="DELIVERY"
            v-model="transport"
            required
          />
          <label class="form-check-label" for="deliveryRadio2"
            >Rozvoz po Praze</label
          >
          <div class="invalid-feedback">Způsob dodání je povinný údaj</div>
        </div>
        <div
          v-if="transport === 'PERSONAL'"
          class="alert alert-warning"
          role="alert"
        >
          <div class="icon">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
          <div>
            Ohledně času osobního odběru Vás budeme kontaktovat a domluvíme
            vzájěmě vyhovující termín.
          </div>
        </div>
        <div
          v-if="transport === 'DELIVERY'"
          class="alert alert-warning"
          role="alert"
        >
          <div class="icon">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
          <div>
            Ohledně času dodávky Vás budeme kontaktovat a domluvíme vzájemně
            vyhovující termín.
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="inputDeliveryAddress" class="col-sm-4 col-form-label"
        >Dodací adresa je shodná s fakturační</label
      >
      <div class="col-sm-8">
        <input
          type="checkbox"
          id="inputDeliveryAddress"
          name="inputDeliveryAddress"
          v-model="order.deliveryAddressSame"
        />
      </div>
    </div>
    <div v-if="!order.deliveryAddressSame" class="form-group row">
      <label for="inputDeliveryName" class="col-sm-4 col-form-label required"
        >Jméno a příjmení (název firmy)</label
      >
      <div class="col-sm-8">
        <input
          type="text"
          v-model="order.deliveryName"
          class="form-control"
          id="inputDeliveryName"
          name="inputDeliveryName"
          placeholder="Jméno a příjmení (název firmy)"
          required
        />
        <div class="invalid-feedback">
          Jméno a přímení nebo název firmy jsou povinný údaj
        </div>
      </div>
    </div>
    <div v-if="!order.deliveryAddressSame" class="form-group row">
      <label for="inputDeliveryStreet" class="col-sm-4 col-form-label required"
        >Ulice a číslo popisné</label
      >
      <div class="col-sm-8">
        <input
          type="text"
          v-model="order.deliveryStreet"
          class="form-control"
          id="inputDeliveryStreet"
          name="inputDeliveryStreet"
          placeholder="Ulice a číslo popisné"
          required
        />
        <div class="invalid-feedback">Ulice je povinný údaj</div>
      </div>
    </div>
    <div v-if="!order.deliveryAddressSame" class="form-group row">
      <label for="inputDeliveryZip" class="col-sm-4 col-form-label required"
        >PSČ</label
      >
      <div class="col-sm-8">
        <input
          type="text"
          v-model="order.deliveryZip"
          class="form-control"
          id="inputDeliveryZip"
          name="inputDeliveryZip"
          placeholder="PSČ"
          required
        />
        <div class="invalid-feedback">PSČ je povinný údaj</div>
      </div>
    </div>
    <div v-if="!order.deliveryAddressSame" class="form-group row">
      <label for="inputDeliveryCity" class="col-sm-4 col-form-label required"
        >Město</label
      >
      <div class="col-sm-8">
        <input
          type="text"
          v-model="order.deliveryCity"
          class="form-control"
          id="inputDeliveryCity"
          name="inputDeliveryCity"
          placeholder="Město"
          required
        />
        <div class="invalid-feedback">Město je povinný údaj</div>
      </div>
    </div>
    <h2>Platba</h2>
    <div class="form-group row">
      <label for="inputDeliveryAddress" class="col-sm-4 col-form-label"
        >Způsob platby</label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            type="radio"
            v-model="order.payment"
            id="paymentRadio1"
            name="paymentRadio"
            class="form-check-input"
            value="ON_DELIVERY"
            required
          />
          <label class="form-check-label" for="paymentRadio1"
            >Hotově při předání</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            v-model="order.payment"
            id="paymentRadio2"
            name="paymentRadio"
            class="form-check-input"
            value="BANK_TRANSFER"
            required
          />
          <label class="form-check-label" for="paymentRadio2">Převodem</label>
          <div class="invalid-feedback">Způsob platby je povinný údaj</div>
        </div>
      </div>
    </div>
    <h2 v-if="taskKey">Vyřízení objednávky</h2>
    <div class="form-group row" v-if="taskKey === 'Form1Pair'">
      <label for="inputPhone" class="col-sm-4 col-form-label required"
        >Fio ID</label
      >
      <div class="col-sm-8">
        <input
          v-model="order.fioId"
          class="form-control"
          id="fioId"
          name="fioId"
          placeholder="Fio Id"
        />
      </div>
    </div>
    <div class="form-group row" v-if="taskKey === 'Form3Invoice'">
      <label for="invoiceInput" class="col-sm-4 col-form-label required"
        >Faktura</label
      >
      <div class="col-sm-8">
        <input
          type="file"
          cam-variable-name="invoice"
          cam-variable-type="File"
          cam-max-filesize="10000000"
        />
      </div>
    </div>

    <div class="form-group row" v-if="taskKey === 'Form2Plan'">
      <label for="inputhandoverDate" class="col-sm-4 col-form-label required"
        >Datum předání</label
      >
      <div class="col-sm-8">
        <date-picker
          v-model="order.deliveryDate"
          :config="options"
        ></date-picker>
      </div>
    </div>
    <div class="form-group row" v-if="taskKey === 'Form4Cancel'">
      <label for="inputNote" class="col-sm-4 col-form-label required"
        >Důvod zrušení</label
      >
      <div class="col-sm-8">
        <textarea
          v-model="order.cancelNote"
          class="form-control"
          id="inputCancelNote"
          name="inputCancelNote"
          placeholder="Důvod zrušení"
          required
        />
      </div>
    </div>

    <div class="form-group row" v-if="taskKey === undefined">
      <div class="col-sm-4" />
      <div class="col-sm-8">
        <div class="form-check">
          <input
            type="checkbox"
            id="agreeConditions"
            name="agreeConditions"
            class="form-check-input"
            v-model="agreeConditions"
            required
          />
          <label for="agreeConditions" class="form-check-label required"
            >Souhlasím s
            <a
              class="modalLink"
              data-toggle="modal"
              data-target="#conditionsDialog"
              >obchodními podmínkami</a
            >
            a s podmínkami
            <a class="modalLink" data-toggle="modal" data-target="#gdprDialog"
              >zpracování obsobních údajů</a
            ></label
          >
        </div>
        <Conditions />
        <Gdpr />

        <div class="form-check">
          <input
            type="checkbox"
            id="agreeAge"
            name="agreeAge"
            class="form-check-input"
            v-model="agreeAge"
            required
          />
          <label for="agreeAge" class="form-check-label required"
            >Souhlasím že jsem starší 18 let, nebo nekupuji alkoholické
            nápoje</label
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Conditions from "../components/Conditions";
import Gdpr from "../components/Gdpr";
// Import this component
import datePicker from "vue-bootstrap-datetimepicker";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  name: "Order",
  components: { datePicker, Conditions, Gdpr },
  data: function () {
    return {
      companyChecked: false,
      dateFieldOpened: false,
      options: {
        format: "DD. MM. YYYY HH:mm",
        useCurrent: true,
        sideBySide: true,
        icons: {
          time: "glyphicon glyphicon-time",
          date: "glyphicon glyphicon-calendar",
          up: "glyphicon glyphicon-chevron-up",
          down: "glyphicon glyphicon-chevron-down",
          next: "glyphicon glyphicon-chevron-right",
          previous: "glyphicon glyphicon-chevron-left",
        },
      },
      agreeConditions: false,
      agreeAge: false,
    };
  },
  props: ["order", "deliveryType", "cartItems", "taskKey"],
  methods: {
    isTransport: function (item) {
      return item.item.image === "transport";
    },
    getVariantName: function (name) {
      if (name === "DELIVERY") {
        return "Rozvoz po Praze";
      } else if (name === "PERSONAL") {
        return "Osobní odběr";
      } else {
        return name;
      }
    },
    open: function (event) {
      event.preventDefault();
      event.stopPropagation();

      this.dateFieldOpened = true;
    },
  },
  computed: {
    transport: {
      get: function () {
        var e = this.cartItems.find(function (element) {
          return element.item.name === "Doprava";
        });
        if (e === undefined) return null;
        else {
          return e.variant.name;
        }
      },
      set: function (newValue) {
        this.$emit("deliveryChange", newValue);
      },
    },
    priceSum: function () {
      if (this.cartItems !== undefined) {
        var toReturn = { withoutVat: 0, vat: 0, withVat: 0 };
        this.cartItems.forEach((element) => {
          toReturn.withoutVat += element.count * element.variant.price;
          toReturn.vat += element.count * element.variant.vat;
          toReturn.withVat +=
            element.count * (element.variant.price + element.variant.vat);
        });
      }
      return toReturn;
    },
  },
};
</script>